import styled from 'styled-components';

export const IconWrapper = styled.div<{ contacted?: boolean }>`
    width: 3rem;
    height: 3rem;
    margin-right: 1rem;
    border-radius: 50%;
    background-color: ${({ theme, contacted }) =>
        contacted ? 'rgb(73 177 135 / 30%)' : theme.colors.darkShadow};

    & > svg {
        width: 50%;
    }

    :hover {
        box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 8px;
        transition: box-shadow 0.3s;
    }
`;
